import {useCallback, useContext} from 'react';
import {isAxiosError} from 'axios';
import {EventBusContext} from '../../../providers/EventBus';
import {getReportError} from '../api/reports.api';

export const useReportError = () => {
  const {bus} = useContext(EventBusContext);
  return useCallback(
    async (error: unknown, fallback: string) => {
      if (isAxiosError(error) && [401, 403].includes(error.response?.status || 0)) {
        bus?.emit('error', [error]);
      }
      const details = await getReportError(error, fallback);
      return details.code === '4007'
        ? {...details, message: 'Отчёт не найден или больше недоступен. Вернитесь к списку отчётов и обновите его.'}
        : details;
    },
    [bus],
  );
};
